<template>
  <div class="flex flex-col">
    <div class="app-content-back">
      <div class="page-title">
        Tricks & Mastery
      </div>
      <div class="flex flex-row flex-wrap p-4">
        <div
          v-for="item in items"
          :key="item.id"
        >
          <div>
            <sc-mastery-small
              :id="item.id"
              :title="item.name"
              :links="item.links"
              :difficulty="item.difficulty"
              :show-add-button="showAddButton"
              :image="item.previewImage"
              @itemSelected="onItemClicked"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import apiService from '../api/apiService'

export default {
    name: 'MasteriesSearch',
    props: {
        showAddButton: {
            type: Boolean,
            required: false
        }
    },
    data () {
        return {
            isBusy: false,
            items: []
        }
    },
    async mounted () {
        await this.readAll()
    },
    methods: {
        onItemClicked (id) {
            this.$emit('itemSelected', id)
        },
        async readAll () {
            if (!this.isBusy) {
                this.isBusy = true
                const response = await apiService.getMasteries()
                this.items = response.data
                try {

                } finally {
                    this.isBusy = false
                }
            }
        }
    }
}
</script>

<style scoped>

</style>